import userRoles from '../userRoles';

export class UserService {
  static isAdmin(user) {
    const currentUserRoles = user.role;

    if (currentUserRoles && Array.isArray(currentUserRoles)) {
      return currentUserRoles.includes(userRoles.ROLE_SUPER_ADMIN);
    }

    return false;
  }

  static isLocalCommunication = user => {
    return user.group === 22;
  };

  static isHairdresser = user => {
    return user.group === 3;
  };

  static isFranchise = user => {
    return user.group === 7;
  };

  static isManager = user => {
    return user.group === 18;
  };

  static hasHairdresserSelected(user) {
    return Boolean(user.hairdresserSelected);
  }

  static hasSomeRoles(user, roles) {
    const currentUserRoles = user.role;

    if (currentUserRoles && Array.isArray(currentUserRoles)) {
      return currentUserRoles.some(
        currentUserRole => roles.indexOf(currentUserRole) >= 0
      );
    }

    return false;
  }
}
